/*========================================================================
* $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2024
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define(["underscore"], function(_) {

  var Guard = function(expression, isOtherwiseGuard) {
    this.expression = expression;
    this.nestedGuards = [];
    this.requiredProperties = {};

    // is data-guard-otherwise
    this.isOtherwiseGuard = isOtherwiseGuard || false;
  }

  _.extend(Guard.prototype, {

      clone: function() {
        var clonedGuard = new Guard(this.expression, this.isOtherwiseGuard);
        clonedGuard.nestedGuards = _.map(this.nestedGuards, function(guard) { return guard.clone(); })
        clonedGuard.requiredProperties = JSON.parse(JSON.stringify(this.requiredProperties || null));
        return clonedGuard;
      },

      evaluate: function (model, application) {
        const evaluationFunction = new Function('model', 'application', 'return ' + this.expression);

        return evaluationFunction.call(/* this context */ null, model, application) 
          && this.nestedGuards.every(function(guard) { return guard.evaluate(this.nestedGuards); })
      },

      addRequiredProperty: function(propertyName) {
        if (!propertyName || propertyName.trim().length === 0) return;

        this.requiredProperties[propertyName.trim()] = {
          formats: ["VALUE"],
        }
      }
  });

  var OtherwiseGuard = function () {
    return new Guard(undefined, true);
  };

  return {
    Guard: Guard, 
    OtherwiseGuard: OtherwiseGuard
  };
});
